module.exports = __webpack_public_path__ + "static/media/books.6248f56d.png";